import { Card, CardContent } from '@/components/ui/card';
import Image from 'next/image';
import Link from 'next/link';

interface DiscussionCardProps {
  category: {
    value: string;
    label: string;
    description?: string;
  };
}

export const DiscussionCard = ({ category }: DiscussionCardProps) => {
  return (
    <Link
      href={`/discussions/category/${category.value}?title=${category.label}&desc=${category.description}`}
    >
      <Card className="bg-ihs-accent-blue shadow-sm outline-none border-none rounded-lg p-4 h-[180px] flex flex-col">
        <CardContent className="px-0 py-0 flex flex-col h-full">
          <div className="mb-2">
            <Image
              src="/discussion-info.svg"
              alt="discussion"
              width={36}
              height={36}
              priority
              rel="preload"
            />
          </div>

          <h4 className="font-bold truncate mb-2">{category.label}</h4>

          <p className="text-sm line-clamp-2 text-[#24292E] tracking-tight flex-grow">
            {category.description || ''}
          </p>
        </CardContent>
      </Card>
    </Link>
  );
};
